export default {
    verifying_login: "登录验证中...",
    login_succeeded: "登录成功",
    validation_failed: "验证失败",
    parameter_acquisition_failed: "参数获取失败",
    loading: "加载中...",
};
